export default __webpack_public_path__ + "static/media/failed.e4ab4d51.svg";